import { gql } from '@apollo/client'

export default gql`
  mutation submitAnswer($assignmentId: ID!) {
    submitAnswer(assignmentId: $assignmentId) {
      id
      assignmentId
      text
      evidence
      submittedAt
      updatedAt
    }
  }
`
